import firebase from 'firebase'
import db from '@/firebase/init'

const state = {
    users: [

    ],
}; 

const getters = {
    allUsers: (state) => state.users
}

const actions = {
    async getAllUsers({ commit }) {
        var users = [];
        //Get data from the firestore
        var collection = db.collection('users')
        const response = await collection.get();
        response.forEach(doc => {
            let user = doc.data()
            user.id = doc.id
            users.push(user);
        });
        commit('setUsers', users)
    },
    async changeUserPermission({ commit }, info) {
        console.log(info)
        db.collection("users").doc(info.userid).update({ permission: info.permission}).then(()=>{
            console.log("Permission updated")
        }).catch((err) => {
            console.log(err)
        })
    },
}

const mutations = {
    setUsers: (state, users) => (state.users = users)
}

export default {
    state,
    getters,
    actions, 
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/users.js